import {AnyAction} from 'redux';
import {Config, StoreActionsEnum} from '../../../modules/hbs-services';

export class ConfigActions {

    static loadConfig(forSignedUser: boolean): AnyAction {
        return {type: StoreActionsEnum.LOAD_CONFIG, payload: {forSignedUser: forSignedUser}};
    }

    static configLoaded(config: Config): AnyAction {
        return {type: StoreActionsEnum.CONFIG_LOADED, payload: {config}};
    }

}
